import { createRouter, createWebHashHistory,createWebHistory } from "vue-router";
import { endActiveCheck, startActiveCheck } from '../utils/activeCheck';
import NProgress from 'nprogress'

export const routes = [
  {
    path: "/",
    redirect: "index",
    hidden: true
  },
  {
    path:"/index",
    name:"index",
    component: () => import("../views/home.vue")
  },
{
    path:"/home",
    name:"home",
    component: () => import("../layout/index.vue"),
  children:[
      {
    path:"/functionadd",
    name:"functionadd",
    component: () => import("../views/menuFunction/functionAdd.vue")
  },
      {
    path:"/function",
    name:"function",
    component: () => import("../views/menuFunction/function.vue")
  },
  {
    path:"/functionedit",
    name:"functionedit",
    component: () => import("../views/menuFunction/functionEdit.vue")
  },
  {
    path:"/personnel",
    name:"personnel",
    component: () => import("../views/personnel/personnel.vue")
  },
  {
    path:"/personneledit",
    name:"personneledit",
    component: () => import("../views/personnel/personnelEdit.vue")
  },
  {
    path:"/personneladd",
    name:"personneladd",
    component: () => import("../views/personnel/personnelAdd.vue")
  },
  {
    path:"/account",
    name:"account",
    component: () => import("../views/account/account.vue")
  },
  {
    path:"/accountadd",
    name:"accountadd",
    component: () => import("../views/account/accountAdd.vue")
  },
  {
    path:"/accountedit",
    name:"accountedit",
    component: () => import("../views/account/accountEdit.vue")
  },
   {
    path:"/editpassword",
    name:"editpassword",
    component: () => import("../views/account/editPassword.vue")
  },
  {
    path:"/role",
    name:"role",
    component: () => import("../views/role/role.vue")
  },
  {
    path:"/roleadd",
    name:"roleadd",
    component: () => import("../views/role/roleAdd.vue")
  },
  {
    path:"/roleedit",
    name:"roleedit",
    component: () => import("../views/role/roleEdit.vue")
  },
  {
    path:"/roleauthorization",
    name:"roleauthorization",
    component: () => import("../views/role/roleAuthorization.vue")
  },
  {
    path:"/accountauthorization",
    name:"accountauthorization",
    component: () => import("../views/account/accountAuthorization.vue")
  },
  {
    path:"/categoryadd",
    name:"categoryadd",
    component: () => import("../views/basicdata/category/categoryAdd.vue")
  },
  {
    path:"/category",
    name:"category",
    component: () => import("../views/basicdata/category/category.vue")
  },
   {
    path:"/categoryedit",
    name:"categoryedit",
    component: () => import("../views/basicdata/category/categoryEdit.vue")
  },
  {
    path:"/clientadd",
    name:"clientadd",
    component: () => import("../views/basicdata/client/clientAdd.vue")
  },
  {
    path:"/client",
    name:"client",
    component: () => import("../views/basicdata/client/client.vue")
  },
   {
    path:"/clientedit",
    name:"clientedit",
    component: () => import("../views/basicdata/client/clientEdit.vue")
  },
  {
    path:"/pictureadd",
    name:"pictureadd",
    component: () => import("../views/basicdata/picture/pictureAdd.vue")
  },
  {
    path:"/picture",
    name:"picture",
    component: () => import("../views/basicdata/picture/picture.vue"),
  },
   {
    path:"/pictureedit",
    name:"pictureedit",
    component: () => import("../views/basicdata/picture/pictureEdit.vue")
  },
  {
    path:"/quote",
    name:"quote",
    component: () => import("../views/basicdata/quote/quote.vue"),
  },
   {
    path:"/quoteedit",
    name:"quoteedit",
    component: () => import("../views/basicdata/quote/quoteEdit.vue")
  },
  {
    path:"/productionorderadd",
    name:"productionorderadd",
    component: () => import("../views/ordermanage/productionorder/productionorderAdd.vue")
  },
  {
    path:"/productionorder",
    name:"productionorder",
    component: () => import("../views/ordermanage/productionorder/productionorder.vue"),
  },
   {
    path:"/productionorderedit",
    name:"productionorderedit",
    component: () => import("../views/ordermanage/productionorder/productionorderEdit.vue")
  },
   {
    path:"/productionorderInsertdata",
    name:"productionorderInsertdata",
    component: () => import("../views/ordermanage/productionorder/productionorderInsertdata.vue")
  },
  {
    path:"/checkdelivery",
    name:"checkdelivery",
    component: () => import("../views/ordermanage/checkdelivery.vue")
  },
  {
    path:"/deliveryorder",
    name:"deliveryorder",
    component: () => import("../views/ordermanage/deliveryorder/deliveryorder.vue"),
  },
  {
    path:"/deliverycontinue",
    name:"deliverycontinue",
    component: () => import("../views/ordermanage/deliveryorder/deliveryContinue.vue")
  },
  {
    path:"/deliverycombine",
    name:"deliverycombine",
    component: () => import("../views/ordermanage/deliveryorder/deliveryCombine.vue")
  },
  {
    path:"/deliveryorderedit",
    name:"deliveryorderedit",
    component: () => import("../views/ordermanage/deliveryorder/deliveryorderEdit.vue")
  },
  {
    path:"/deliverystatistics",
    name:"deliverystatistics",
    component: () => import("../views/ordermanage/deliveryorder/deliverystatistics.vue")
  },
  {
    path:"/deliverystatisticsedit",
    name:"deliverystatisticsedit",
    component: () => import("../views/ordermanage/deliveryorder/deliverystatisticsEdit.vue")
  },
  {
    path:"/checkbill",
    name:"checkbill",
    component: () => import("../views/billingmanage/checkbill.vue")
  },
  {
    path:"/reconciliation",
    name:"reconciliation",
    component: () => import("../views/billingmanage/reconciliation/reconciliation.vue"),
  },
  {
    path:"/billingmanageedit",
    name:"billingmanageedit",
    component: () => import("../views/billingmanage/reconciliation/reconciliationEdit.vue")
  },
  {
    path:"/reconciliationFactory",
    name:"reconciliationFactory",
    component: () => import("../views/billingmanage/reconciliationFactory/reconciliationFactory.vue"),
  },
  {
    path:"/billingmanageFactoryedit",
    name:"billingmanageFactoryedit",
    component: () => import("../views/billingmanage/reconciliationFactory/reconciliationFactoryEdit.vue")
  },
  {
    path:"/diamondsadd",
    name:"diamondsadd",
    component: () => import("../views/basicdata/diamonds/diamondsAdd.vue")
  },
  {
    path:"/diamonds",
    name:"diamonds",
    component: () => import("../views/basicdata/diamonds/diamonds.vue")
  },
   {
    path:"/diamondsedit",
    name:"diamondsedit",
    component: () => import("../views/basicdata/diamonds/diamondsEdit.vue")
  },
  {
    path:"/costadd",
    name:"costadd",
    component: () => import("../views/basicdata/cost/costAdd.vue")
  },
  {
    path:"/cost",
    name:"cost",
    component: () => import("../views/basicdata/cost/cost.vue")
  },
   {
    path:"/costedit",
    name:"costedit",
    component: () => import("../views/basicdata/cost/costEdit.vue")
  },
]
  }
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});
export default router;
// 路由加载后
router.afterEach((to) => {
  NProgress.done();
  if (to.path === '/index') {
    endActiveCheck()
  } else {
    startActiveCheck()
  }
});
